
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

export class ScanlineBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height, time, config } = bc;
        
        ctx.fillStyle = config.backgroundPrimaryColor;
        ctx.fillRect(0, 0, width, height);

        const spacing = 4;
        const offset = (time * 50) % spacing;

        ctx.strokeStyle = config.backgroundSecondaryColor;
        ctx.lineWidth = 1;
        ctx.globalAlpha = 0.3;

        for (let y = offset; y < height; y += spacing) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }
        
        ctx.globalAlpha = 1.0;
    }
}
